import React from "react";

const PanelBody = ({ content }) => {
  return (
    <div className="px-6 py-4 bg-secondary dark:bg-darkPrimary text-textColor dark:text-darkTextColor">
      {content}
    </div>
  );
};

export default PanelBody;
